import styled from "styled-components";

const StyledRect = styled.rect`
  fill: ${(props) => props.theme.backgroundColor};
`

const Gate = ({num, orbitcolor}) => {

   const gateImages = [
      <g>
         <path fill={orbitcolor} d="M2956.45,806.51a64.53,64.53,0,0,0,56.93-34.11l-10-5.39a53.08,53.08,0,0,1-86.2,10.63,64.39,64.39,0,0,0,66.26-83l-10.91,3.3a53.07,53.07,0,0,1-53.43,68.46,64.39,64.39,0,0,0-11.84-105.54l-5.39,10a53.07,53.07,0,0,1,10.64,86.19,64.4,64.4,0,0,0-83-66.25l3.29,10.9a53.09,53.09,0,0,1,68.46,53.43A64.4,64.4,0,0,0,2795.69,767l10,5.39a53.07,53.07,0,0,1,86.18-10.64,64.4,64.4,0,0,0-66.24,83l10.91-3.3A53.07,53.07,0,0,1,2890,773a64.39,64.39,0,0,0,11.84,105.53l5.39-10a53.06,53.06,0,0,1-10.63-86.18,64.47,64.47,0,0,0,83,66.26l-3.29-10.91a53.07,53.07,0,0,1-68.46-53.43A64.38,64.38,0,0,0,2956.45,806.51Z"/>
         <g>
            <StyledRect x="3030.12" y="614.27" width="151.94" height="151.94"/>
            <path d="M3172.66,624.27V756.81H3040.12V624.27h132.54m10-10H3030.12V766.81h152.54V614.27Z"/>
            <path d="M3101.64,662.92h-17.25v-11.7c14,0,18.9-3,22.65-13.2h11.1V743h-16.5Z"/>
         </g>
      </g>,

      <g>
         <path fill={orbitcolor} d="M384.63,1975.89a64.52,64.52,0,0,0,56.93-34.1l-10-5.39a53.1,53.1,0,0,1-86.2,10.63,64.4,64.4,0,0,0,66.26-83l-10.91,3.29a53.07,53.07,0,0,1-53.43,68.47,64.39,64.39,0,0,0-11.84-105.54l-5.39,10a53.07,53.07,0,0,1,10.64,86.19,64.4,64.4,0,0,0-83-66.26l3.29,10.91a53.08,53.08,0,0,1,68.46,53.42,64.41,64.41,0,0,0-105.54,11.85l10,5.39a53.07,53.07,0,0,1,86.18-10.64,64.4,64.4,0,0,0-66.24,83l10.91-3.3a53.07,53.07,0,0,1,53.41-68.46A64.39,64.39,0,0,0,330,2047.93l5.39-10a53.06,53.06,0,0,1-10.63-86.18,64.47,64.47,0,0,0,83,66.25l-3.29-10.91A53.07,53.07,0,0,1,336,1953.62,64.35,64.35,0,0,0,384.63,1975.89Z"/>
         <g>
            <StyledRect x="458.3" y="1783.66" width="151.94" height="151.94"/>
            <path d="M600.84,1793.66V1926.2H468.3V1793.66H600.84m10-10H458.3V1936.2H610.84V1783.66Z"/>
            <path d="M529.82,1832.3H512.57v-11.69c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
         </g>
      </g>
   ]

  const index = num-1
  return (
    gateImages[index]
  )
}

export default Gate
